
// src/web/components/confirm-google-login.jsx

import React from 'react'
import { translate } from 'react-i18next'
import Dialog from 'react-toolbox/lib/dialog'
import FontIcon from 'react-toolbox/lib/font_icon'
import { GoogleLogin } from './google-signin-provider.jsx'
import config from '../../config'

function ConfirmGoogleLogin(props) {
  const {
    t,
    open = false,
    onSuccess,
    onClose,
  } = props

  return (
    <Dialog active={open}
      onEscKeyDown={onClose}
      onOverlayClick={onClose}
      title={t('label:Googleドキュメントに接続')}
      actions={[
        { label: t('label:取り消し'), onClick: onClose, raised: true },
      ]}>
      <GoogleLogin label={t('label:Googleドキュメントに接続')} onSuccess={onSuccess} />
    </Dialog>
  )
}

export default translate()(ConfirmGoogleLogin)



// WEBPACK FOOTER //
// ./src/web/components/confirm-google-login.jsx